module.exports = __webpack_public_path__ + "images/arrow-icon.png";


//////////////////
// WEBPACK FOOTER
// ./homepage/images/arrow-icon.png
// module id = 855
// module chunks = 0